import {
  type CheckboxProps,
  Checkbox as HeroUiCheckbox,
} from '@heroui/checkbox'
import { createInput } from './input-factory'

export const Checkbox: React.FC<CheckboxProps> = ({ value, ...rest }) => {
  return <HeroUiCheckbox isSelected={Boolean(value)} {...rest} />
}

export const FormCheckbox = createInput(Checkbox, ['form'])
